export default function FormattedPlural(props) {
    return props.value === 1 ? props.one : props.other;
}
